var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardWiredStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4649 9.72247C15.4146 8.62839 16.7921 8 18.2409 8H41.8507C43.3227 8 44.7199 8.64863 45.6699 9.77302L47.3469 11.7578C48.4144 13.0212 49 14.6217 49 16.2756V44C49 46.7614 46.7614 49 44 49H16C13.2386 49 11 46.7614 11 44L11 16.3286C11 14.6426 11.6085 13.0132 12.7137 11.74L14.4649 9.72247Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 12.75,
    width: 36.5,
    height: 35.5,
    rx: 4,
    fill: "url(#paint0_linear_3235_85492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_85492",
    x1: 30,
    y1: 12.75,
    x2: 30,
    y2: 48.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardWiredStatus);
export default __webpack_public_path__ + "static/media/icn_dashboard_wired_status.59b3373edc83abd9a9cc5c2c237394d5.svg";
export { ForwardRef as ReactComponent };